import { Grid } from '@wrisk/ui-components'
import React from 'react'

import { Quote } from '../../../domain'
import { CoreCoversList } from './CoreCoversList'

interface IncludedCoverItemsProps {
  quote: Quote
}

export const IncludedCoverItems: React.FC<IncludedCoverItemsProps> = ({ quote }) => {
  return (
    <Grid width={1} p={2} alignItems='stretch'>
      <CoreCoversList quote={quote} />
    </Grid>
  )
}
